<template>
  <el-dialog class="course-dialog scoreDialog" :visible.sync="scoreDialogVisible.show" :close-on-click-modal="false" :show-close="false">
    <div class="playboxscore">
      <div class="playboxscore-content">
        <div class="course-title">
          <img class="course-title-img" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/common/course-title-span.png"/>
          <span :class="frFont ? 'course-title-span course-title-font' : 'course-title-span'">{{info.title}}</span>
        </div>
        <div class="title">感谢您对<span class="name">{{info.name}}</span>作出评价</div>
        <div class="course-pfwjx2">
            <div class="item" v-for="(item) in info.scoreArr" :key="item.label">
              <span class="label">{{item.label}}</span>
              <p v-for="numbercount in item.count" :key="numbercount">
                <span @click="clickbright(numbercount,item)">
                  <svg-icon icon-class="score-star" class-name="score-star-icon-huang "></svg-icon>
                </span>
              </p>
              <p v-for="numbercount in 5-item.count" :key="numbercount+item.count">
                <span @click="clickbright(numbercount+item.count,item)">
                  <svg-icon icon-class="score-star" class-name="score-star-icon-gray"></svg-icon>
                </span>
              </p>
              <!-- <span class="text">5分</span>  -->
            </div>
        </div>
        
        <!-- <div class="course-tip" v-if="issubmit">
          {{$t('WDNPC_WEB_CLICK_XINGX_TO_COMMENT',{text:'点击星星可以进行评价哦'})}}
        </div> -->
        <div v-if="!issubmit" class="course-footer course-footer1">
          <el-button @click="clickclose">{{$t('WDNPC_WEB_CANCEL',{text:'取消'})}}</el-button>
          <!--  -->
          <el-button type="primary" :class="!isSubmitButton?'course-active':''"  @click="clickSubmit">{{$t('WDNPC_WEB_SUBMIT',{text:'提交'})}}</el-button>
        </div>
        <div v-else class="course-footer course-footer2">
          <el-button type="primary" @click="clickclose">{{$t('WDNPC_WEB_CLOSE',{text:'关闭'})}}</el-button>
        </div>
      </div>
    </div>
</el-dialog>

  
</template>
<script>

export default {
  name: "scoreDialog",
  props: {
    info:{
        type:Object,
        default: () => {},
    },
    scoreDialogVisible:{
      type:Object,
      default:() => ({
          show:false
      })
    },
    issubmit:{type:Boolean,default:false},

  },

  data () {
    return{
      show:true,
      frFont:false,//是否是法语

    }
  },
  computed:{
    isSubmitButton(){
      let num = false;
      this.info.scoreArr.forEach(item => {
        if(item.count){
            num = true;
        }
      })
      return num
    },
  },
  created () {
    if(localStorage.getItem('current_language') && localStorage.getItem('current_language') == 'fr-FR'){
      this.frFont = true
    }else{
      this.frFont = false
    }
  },
  async mounted () {
   
  },
 
  methods:{
    clickbright(clickbright,item){
      if(this.issubmit){
          return false;
      }
      item.count = clickbright;
      if(clickbright){
        this.isSubmitActive = true;
      }
      console.log(this.isSubmitActive,'isSubmitActive====')
    },
    getParent (parent, fn,item) {
        if (parent[fn]) {
            parent[fn](item)
        } else {
            this.getParent(parent.$parent, fn,item)
        }
    },
    clickclose(){
      this.getParent(this.$parent, 'clickclose');
    },
    clickSubmit(){
      let num = 0;
      this.info.scoreArr.forEach(item => {
          if(item.count){
              num ++ ;
          }
      })
      if(num){
          this.getParent(this.$parent, 'evaluateCourse',this.info.scoreArr);
      }else{
          this.$message.warning('请做出评价')
      }
     
      
      
    },
  },
};
</script>
<style lang="stylus">
  .course-dialog .el-dialog
    background: none !important;
    box-shadow: none !important;
  .scoreDialog .playboxscore
    .title{
        margin-top: 14px;
        margin-bottom: 33px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #202124;
        line-height: 20px;
        // text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
        .name{
            color: #407AF7;
            font-size: 20px;
        }
    }
    &-content
      width 400px
      background #FFFFFF
      box-shadow 0px 0px 20px 0px rgba(0, 0, 0, 0.1)
      border-radius 10px
      margin 0 auto
      text-align center
      margin-top 80px
      padding-bottom 30px
      
      .course-title
        height 80px
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .course-title-img
          width 295px
          height 231px
          position: absolute;
          left: 53px;
          top: -151px;
        // .course-close
        //   width 64px
        //   position: absolute;
        //   right: 24px;
        //   top: 14px;
        .course-title-span
          position:absolute;
          color: #fff;
          font-size:26px;
        .course-title-font
          font-size:15px;
      .course-tip
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        margin-top:16px;
        padding-bottom:5px;
      .course-pfwjx2
        // padding-bottom 16px
        margin-top: 33px
        .item{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            .label{
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #202124;
              line-height: 16px;
              // text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
              margin-right: 15px;
            }
        }
        .score-star-icon-huang{
            font-size:32px;
            color:#FFD118;
        }
        .score-star-icon-gray{
           font-size:32px;
           color:#D8D8D8;
        }
        p
          margin-right 8px
          &:last-child
            margin-right 0px
          img
            width 48px
            cursor pointer
      .course-footer
        margin-top: 40px;
      .course-footer1
        .el-button--primary:active
          outline: 0;
        .el-button
          width: 120px;
          height: 40px;
          line-height:38px;
          font-size: 16px;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          padding:0px;
        .el-button--default
          background: #FFFFFF;
          border: 1px solid #D7DCEE;
          color: #666666;
          box-sizing:border-box;
        .el-button--primary
          background: rgba(49, 111, 255, 1);
          color: #FFFFFF;
          border:none;
          opacity:1;
          margin-left:30px;
        .course-active.el-button--primary
          background: rgba(49, 111, 255, 0.3);
      .course-footer2
        .el-button
          width: 240px;
          height: 40px;
          background: #316FFF;
          margin:0 auto;
          border:none;



</style>
